import React from 'react';
import HBSwitch, { HBSwitchProps } from '../HBSwitch/HBSwitch';
import HBSwitchField, {
    HBSwitchFieldProps
} from '../HBSwitchField/HBSwitchField';
import useFormFieldProps, {
    FormFieldProps,
    useFormInputProps,
    useFormInputValidationProps
} from './useFormFieldProps';

const HBFormSwitchField = (props: FormFieldProps<HBSwitchFieldProps>) => {
    const fieldProps = useFormFieldProps(props);
    const validationProps = useFormInputValidationProps(props.id);

    return (
        <HBSwitchField
            {...fieldProps}
            {...validationProps}
            checked={fieldProps.value}
        />
    );
};

export const FormSwitch = (props: FormFieldProps<HBSwitchProps>) => {
    const inputProps = useFormInputProps(props);
    const validationProps = useFormInputValidationProps(props.id);

    return (
        <HBSwitch {...inputProps} {...validationProps} label={props.label} />
    );
};

export default HBFormSwitchField;
